// import React, { useState, useEffect } from "react";
// import createInstance from "../../../api/axiosinstance";
// import { toast } from "react-toastify";
// import Loader from "../../Loader";
// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";
// import { useSelector } from "react-redux";
// import {
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Paper,
//   Button,
// } from "@mui/material"; // Assuming bootstrap for consistency, adjust if needed
// // import COLORS from "../../Themes/Colours";
// import { useThemeMode } from "../../Themes/ThemeContextTemp.js";

// const ViewModal = ({
//   isOpen,
//   onClose,
//   title,
//   feedback,
//   rating,
//   candidateId,
//   interview,
//   onUpdate,
//   isReadOnly,
// }) => {
//   const aiDishaApi = createInstance("DISHA")
//   const { COLORS, theme, toggleTheme } = useThemeMode();
//   const [candidateDetails, setCandidateDetails] = useState({});
//   const [editableFields, setEditableFields] = useState({
//     interview_panel: [],
//     meeting_link: "",
//     round: "",
//     interview_duration: "",
//     reschedule: "Yes",
//     key_notes: "",
//     select_interviewer: "",
//   });
//   const [selectedDate, setSelectedDate] = useState(null);
//   const [selectedTime, setSelectedTime] = useState(null);
//   const [meetingLink, setMeetingLink] = useState("");
//   const [meetingId, setMeetingId] = useState("");
//   const [isLoading, setIsLoading] = useState(false);
//   const [isGeneratingZoom, setIsGeneratingZoom] = useState(false);
//   const [technologists, setTechnologists] = useState([]);
//   const [managers, setManagers] = useState([]);
//   const [hrs, setHrs] = useState([]);
//   const [interviewerList, setInterviewerList] = useState([]);
//   const [tpInterviewers, setTpInterviewers] = useState([]);
//   const [selectedTpInterviewer, setSelectedTpInterviewer] = useState([]);
//   const [hasChangedDate, setHasChangedDate] = useState(false);
//   const [hasChangedTime, setHasChangedTime] = useState(false);
//   const { user } = useSelector((state) => state.auth);
//   const organizationId = user?.organizationId;
//   const hrId = user?.orgUserId;

//   const getCurrentDateTime = () => {
//     const now = new Date();
//     return now;
//   };

//   useEffect(() => {
//     if (candidateId) {
//       getCandidateDetails();
//     }
//   }, [candidateId]);

//   useEffect(() => {
//     if (isOpen) {
//       getInterviewers();
//       getAllTpInterviewers();
//     }
//   }, [isOpen]);

//   useEffect(() => {
//     if (editableFields.round && editableFields.select_interviewer) {
//       updateInterviewerList(
//         editableFields.round,
//         editableFields.select_interviewer
//       );
//     }
//   }, [
//     editableFields.round,
//     editableFields.select_interviewer,
//     technologists,
//     managers,
//     hrs,
//   ]);

//   const updateInterviewerList = (round, selectInterviewer) => {
//     if (!round || !selectInterviewer) {
//       setInterviewerList([]);
//       return;
//     }
//     if (selectInterviewer === "Third Party Interviewer") {
//       setInterviewerList([]); // Use separate TP list
//       return;
//     }
//     // Same logic as ScheduleInterview - filter by round
//     if (round === "Technical Round 1" || round === "Technical Round 2") {
//       setInterviewerList(technologists);
//     } else if (round === "Managerial") {
//       setInterviewerList(managers);
//     } else if (round === "HR") {
//       setInterviewerList(hrs);
//     } else {
//       setInterviewerList([]);
//     }
//   };

//   const getInterviewers = async () => {
//     setIsLoading(true);
//     try {
//       const response = await aiDishaApi.get(
//         `/get_interviewers?org_id=${organizationId}`
//       );
//       const interviewers = response.data;
//       setTechnologists(interviewers["Technical"] || []);
//       setHrs(interviewers["HR"] || []);
//       setManagers(interviewers["Managerial"] || []);
//       if (editableFields.round && editableFields.select_interviewer) {
//         updateInterviewerList(
//           editableFields.round,
//           editableFields.select_interviewer
//         );
//       }
//     } catch (error) {
//       console.log("Error fetching interviewers", error);
//       toast.error("Failed to fetch interviewers list");
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const getAllTpInterviewers = async () => {
//     try {
//       const response = await aiDishaApi.get(
//         "/get-all-interviewer"
//       );
//       const users = response.data["active_users"] || [];
//       setTpInterviewers(users.filter((u) => u.role === "TP-Interviewer"));
//     } catch (error) {
//       console.error("Error fetching TP interviewers:", error);
//       toast.error("Failed to fetch TP Interviewers. Please try again.");
//     }
//   };

//   const getCandidateDetails = async () => {
//     if (!candidateId) return;
//     await aiDishaApi
//       .get(`/get-candidates-by-candidate-id?candidate_id=${candidateId}`)
//       .then((response) => {
//         setCandidateDetails(response.data);
//       })
//       .catch((error) => {
//         console.log("Error fetching candidate performance details", error);
//       });
//   };

//   // Auto-generate Zoom link only when both date and time are user-changed
//   useEffect(() => {
//     const generateZoomLink = async () => {
//       if (
//         !isReadOnly &&
//         selectedDate &&
//         selectedTime &&
//         hasChangedDate &&
//         hasChangedTime
//       ) {
//         setIsGeneratingZoom(true);
//         try {
//           const formattedDate = `${selectedDate.getFullYear()}-${String(
//             selectedDate.getMonth() + 1
//           ).padStart(2, "0")}-${String(selectedDate.getDate()).padStart(
//             2,
//             "0"
//           )}`;
//           const formattedTime = `${String(selectedTime.getHours()).padStart(
//             2,
//             "0"
//           )}:${String(selectedTime.getMinutes()).padStart(2, "0")}`;
//           const response = await aiDishaApi.post("/zoom-meeting-creator/", {
//             date: formattedDate,
//             time: formattedTime,
//           });
//           setMeetingLink(response.data["Join URL"]);
//           setMeetingId(String(response.data["Meeting ID"]));
//           toast.success("Zoom meeting link generated successfully");
//           setEditableFields((prev) => ({
//             ...prev,
//             meeting_link: response.data["Join URL"],
//           }));
//         } catch (error) {
//           console.error("Error generating Zoom link:", error);
//           toast.error("Failed to generate Zoom meeting link");
//           setMeetingLink("");
//           setMeetingId("");
//           setEditableFields((prev) => ({ ...prev, meeting_link: "" }));
//         } finally {
//           setIsGeneratingZoom(false);
//         }
//       } else {
//         // Set to existing or clear
//         if (selectedDate && selectedTime) {
//           setMeetingLink(interview?.meeting_link || "");
//           setMeetingId(interview?.zoom_meeting_id || "");
//           setEditableFields((prev) => ({
//             ...prev,
//             meeting_link: interview?.meeting_link || "",
//           }));
//         } else {
//           setMeetingLink("");
//           setMeetingId("");
//           setEditableFields((prev) => ({ ...prev, meeting_link: "" }));
//         }
//       }
//     };
//     generateZoomLink();
//   }, [
//     selectedDate,
//     selectedTime,
//     hasChangedDate,
//     hasChangedTime,
//     isReadOnly,
//     interview,
//   ]);

//   useEffect(() => {
//     if (isOpen && interview) {
//       let dateObj = null;
//       let timeObj = null;
//       let dateTimeField =
//         interview.round === "Technical Round 2"
//           ? interview["Technical Round 2 interview_date_and_time"] ||
//             interview.interview_date_and_time
//           : interview.interview_date_and_time;
//       if (dateTimeField) {
//         try {
//           const parsedDate =
//             dateTimeField.includes("Z") || dateTimeField.includes("+")
//               ? new Date(dateTimeField)
//               : new Date(dateTimeField + "Z");
//           if (!isNaN(parsedDate.getTime())) {
//             // Convert UTC to IST for display
//             const istDate = new Date(
//               parsedDate.getTime() + 5.5 * 60 * 60 * 1000
//             );
//             dateObj = new Date(
//               istDate.getFullYear(),
//               istDate.getMonth(),
//               istDate.getDate()
//             );
//             timeObj = new Date(istDate.getTime());
//             setSelectedDate(dateObj);
//             setSelectedTime(timeObj);
//           } else {
//             console.error("Invalid interview date:", dateTimeField);
//             setSelectedDate(null);
//             setSelectedTime(null);
//           }
//         } catch (e) {
//           console.error("Error parsing date:", e);
//           setSelectedDate(null);
//           setSelectedTime(null);
//         }
//       } else {
//         setSelectedDate(null);
//         setSelectedTime(null);
//       }

//       // Set existing meeting details
//       setMeetingLink(interview.meeting_link || "");
//       setMeetingId(interview.zoom_meeting_id || "");

//       setEditableFields({
//         interview_panel: interview.interview_panel || "",
//         meeting_link: interview.meeting_link || "",
//         round: interview.round || "",
//         interview_duration: interview.interview_duration || "",
//         reschedule: interview.Reschedule || "Yes",
//         key_notes: interview.key_notes || interview.keynotes || "",
//         select_interviewer: interview.select_interviewer || "",
//       });

//       // Set TP interviewer if applicable
//       if (
//         interview.select_interviewer === "Third Party Interviewer" &&
//         interview.interview_panel
//       ) {
//         setSelectedTpInterviewer(interview.interview_panel);
//       }

//       if (interview.round && interview.select_interviewer) {
//         updateInterviewerList(interview.round, interview.select_interviewer);
//       }
//     }
//   }, [isOpen, interview]);

//   const handleClose = () => {
//     setCandidateDetails({});
//     setSelectedDate(null);
//     setSelectedTime(null);
//     setMeetingLink("");
//     setMeetingId("");
//     setHasChangedDate(false);
//     setHasChangedTime(false);
//     setEditableFields({
//       interview_panel: [],
//       meeting_link: "",
//       round: "",
//       interview_duration: "",
//       reschedule: "Yes",
//       key_notes: "",
//       select_interviewer: "",
//     });
//     setSelectedTpInterviewer([]);
//     onClose();
//   };

//   const handleInputChange = (e) => {
//     if (isReadOnly) return;
//     const { name, value } = e.target;
//     setEditableFields((prev) => ({
//       ...prev,
//       [name]: value,
//       // Reset selected interviewer whenever round or type changes
//       ...(name === "round" || name === "select_interviewer"
//         ? { interview_panel: [] }
//         : {}),
//     }));
//     if (name === "round" || name === "select_interviewer") {
//       setSelectedTpInterviewer([]);
//     }
//   };

//   const handleSelectInterviewer = (panelist_id) => {
//     if (isReadOnly) return;
//     setEditableFields((prev) => ({
//       ...prev,
//       interview_panel: prev.interview_panel.includes(panelist_id)
//       ? prev.interview_panel.filter((id) => id !== panelist_id)
//       : [...prev.interview_panel, panelist_id],
//     }));
//   };

//   const handleSelectTpInterviewer = (user_id) => {
//     if (isReadOnly) return;
//     setSelectedTpInterviewer((prev) => {
//     const updated = prev.includes(user_id)
//       ? prev.filter((id) => id !== user_id)
//       : [...prev, user_id];
//     setEditableFields((prevFields) => ({
//       ...prevFields,
//       interview_panel: updated,
//     }));
//     return updated;
//   });
// };

//   const validateForm = () => {
//     if (isReadOnly) return true;
//     if (!candidateId.trim()) {
//       toast.error("Candidate ID cannot be empty");
//       return false;
//     }
//     if (!editableFields.round.trim()) {
//       toast.error("Round cannot be empty");
//       return false;
//     }
//     if (!editableFields.select_interviewer.trim()) {
//       toast.error("Select Interviewer Type cannot be empty");
//       return false;
//     }
//     if (!editableFields.key_notes.trim()) {
//       toast.error("Key notes cannot be empty");
//       return false;
//     }
//     const selectedPanel =
//       editableFields.select_interviewer === "Third Party Interviewer"
//         ? selectedTpInterviewer
//         : editableFields.interview_panel;
//     if (!selectedPanel || selectedPanel.length === 0) {
//       toast.error("Please select an Interviewer");
//       return false;
//     }
//     if (!selectedDate || !selectedTime) {
//       toast.error("Interview Date and Time cannot be empty");
//       return false;
//     }
//     if (!meetingLink.trim()) {
//       toast.error(
//         "Meeting Link cannot be empty. Please select date and time first."
//       );
//       return false;
//     }
//     if (!meetingId.trim()) {
//       toast.error(
//         "Meeting ID cannot be empty. Please select date and time first."
//       );
//       return false;
//     }
//     if (
//       !editableFields.interview_duration.trim() ||
//       isNaN(editableFields.interview_duration) ||
//       editableFields.interview_duration <= 0
//     ) {
//       toast.error("Please enter a valid interview duration in minutes");
//       return false;
//     }
//     const combinedDateTime = new Date(
//       selectedDate.getFullYear(),
//       selectedDate.getMonth(),
//       selectedDate.getDate(),
//       selectedTime.getHours(),
//       selectedTime.getMinutes()
//     );
//     const now = new Date();
//     if (combinedDateTime <= now) {
//       toast.error("Please select a future date and time");
//       return false;
//     }
//     return true;
//   };

//   const handleReset = () => {
//     if (isReadOnly) return;
//     if (interview) {
//       let dateObj = null;
//       let timeObj = null;
//       let dateTimeField =
//         interview.round === "Technical Round 2"
//           ? interview["Technical Round 2 interview_date_and_time"] ||
//             interview.interview_date_and_time
//           : interview.interview_date_and_time;
//       if (dateTimeField) {
//         try {
//           const parsedDate =
//             dateTimeField.includes("Z") || dateTimeField.includes("+")
//               ? new Date(dateTimeField)
//               : new Date(dateTimeField + "Z");
//           if (!isNaN(parsedDate.getTime())) {
//             const istDate = new Date(
//               parsedDate.getTime() + 5.5 * 60 * 60 * 1000
//             );
//             dateObj = new Date(
//               istDate.getFullYear(),
//               istDate.getMonth(),
//               istDate.getDate()
//             );
//             timeObj = new Date(istDate.getTime());
//             setSelectedDate(dateObj);
//             setSelectedTime(timeObj);
//           } else {
//             setSelectedDate(null);
//             setSelectedTime(null);
//           }
//         } catch (e) {
//           console.error("Error parsing date on reset:", e);
//           setSelectedDate(null);
//           setSelectedTime(null);
//         }
//       } else {
//         setSelectedDate(null);
//         setSelectedTime(null);
//       }

//       setMeetingLink(interview.meeting_link || "");
//       setMeetingId(interview.zoom_meeting_id || "");

//       setEditableFields({
//         interview_panel: iArray.isArray(interview.interview_panel) 
//     ? interview.interview_panel 
//     : interview.interview_panel ? [interview.interview_panel] : [],
//         meeting_link: interview.meeting_link || "",
//         round: interview.round || "",
//         interview_duration: interview.interview_duration || "",
//         reschedule: interview.Reschedule || "Yes",
//         key_notes: interview.key_notes || interview.keynotes || "",
//         select_interviewer: interview.select_interviewer || "",
//       });

//       if (
//         interview.select_interviewer === "Third Party Interviewer" &&
//         interview.interview_panel
//       ) {
//         setSelectedTpInterviewer(Array.isArray(interview.interview_panel) 
//       ? interview.interview_panel 
//       : [interview.interview_panel]
//     );
//       }

//       if (interview.round && interview.select_interviewer) {
//         updateInterviewerList(interview.round, interview.select_interviewer);
//       }

//       // Reset change flags
//       setHasChangedDate(false);
//       setHasChangedTime(false);
//     }
//   };

//   const handleSubmit = async () => {
//     if (isReadOnly) return;
//     if (!validateForm()) return;
//     if (!interview) return;
//     setIsLoading(true);
//     try {
//       // Convert IST to UTC by subtracting 5.5 hours
//       const combinedDateTime = new Date(
//         selectedDate.getFullYear(),
//         selectedDate.getMonth(),
//         selectedDate.getDate(),
//         selectedTime.getHours(),
//         selectedTime.getMinutes(),
//         0
//       );
//       const utcDateTime = new Date(
//         combinedDateTime.getTime() - 5.5 * 60 * 60 * 1000
//       );
//       const formattedDateTime = utcDateTime.toISOString();

//       const selectedPanel =
//         editableFields.select_interviewer === "Third Party Interviewer"
//           ? selectedTpInterviewer
//           : editableFields.interview_panel;

//       // const params = new URLSearchParams({
//       //   interview_id: interview.interview_id,
//       //   organization_id: organizationId,
//       //   Hr_id: hrId,
//       //   candidate_id: interview.candidate_id,
//       //   candidate_name: interview.candidate_name,
//       //   job_title: interview.job_title,
//       //   Interview_panel: selectedPanel,
//       //   link: meetingLink,
//       //   zoom_meeting_id: meetingId,
//       //   round: editableFields.round,
//       //   select_interviewer: editableFields.select_interviewer,
//       //   Key_notes: editableFields.key_notes,
//       //   interview_duration: editableFields.interview_duration,
//       //   Reschedule: editableFields.reschedule,
//       // });

//       const params = new URLSearchParams();
// params.append("interview_id", interview.interview_id);
// params.append("organization_id", organizationId);
// params.append("Hr_id", hrId);
// params.append("candidate_id", interview.candidate_id);
// params.append("candidate_name", interview.candidate_name);
// params.append("job_title", interview.job_title);
// selectedPanel.forEach((id) => params.append("Interview_panel", id)); // key fix
// params.append("link", meetingLink);
// params.append("zoom_meeting_id", meetingId);
// params.append("round", editableFields.round);
// params.append("select_interviewer", editableFields.select_interviewer);
// params.append("Key_notes", editableFields.key_notes);
// params.append("interview_duration", editableFields.interview_duration);
// params.append("Reschedule", editableFields.reschedule);

//       const url = `/update_interview?${params.toString()}`;
//       const requestBody = {
//         status: "Active",
//         interview_date_and_time: formattedDateTime,
//       };

//       const response = await aiDishaApi.put(url, requestBody);
//       toast.success("Interview updated successfully");
//       if (onUpdate) onUpdate();
//       handleClose();
//     } catch (error) {
//       console.error("Error updating interview:", error);
//       toast.error(
//         "Failed to update interview: " + (error.message || "Unknown error")
//       );
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   if (!isOpen) return null;

//   return (
//     <div
//       className={`modal fade ${isOpen ? "show" : ""}`}
//       tabIndex="-1"
//       style={{
//         display: isOpen ? "block" : "none",
//         backgroundColor: "rgba(0,0,0,0.5)",
//         zIndex: 1050,
//         position: "fixed",   
//     top: 40,              
//     left:140,             
//     width: "100vw",      
//     height: "100vh",     
//       }}
//     >
//       {/* <div className="modal-dialog modal-xl modal-dialog-centered"> */}
//       <div className="modal-dialog modal-xl modal-dialog-centered view-modal-shift"
//       style={{
//     margin: "auto !important",    
//   }}>
//         <div
//           className="modal-content"
//           style={{ background: COLORS.primary, position: "relative" }}
//         >
//           {(isLoading || isGeneratingZoom) && (
//             <>
//               <div
//                 style={{
//                   position: "absolute",
//                   top: 0,
//                   left: 0,
//                   width: "100%",
//                   height: "100%",
//                   backgroundColor: "rgba(0, 0, 0, 0.5)",
//                   zIndex: 999,
//                 }}
//               />
//               <div
//                 style={{
//                   position: "absolute",
//                   top: "50%",
//                   left: "50%",
//                   transform: "translate(-50%, -50%)",
//                   zIndex: 1000,
//                 }}
//               >
//                 <Loader />
//               </div>
//             </>
//           )}
//           <div className="modal-header border-0">
//             <label style={{ color: COLORS.text, fontSize: "18px" }}>
//               {title || "Candidate Performance"}
//             </label>
//             <button
//               type="button"
//               className="btn-close"
//               onClick={handleClose}
//             ></button>
//           </div>
//           <div
//             style={{
//               padding: "20px",
//               height: "calc(100vh - 200px)",
//               overflowY: "auto",
//             }}
//           >
//             {/* Candidate Info Row */}
//             <div className="row" style={{ margin: "0% 2%" }}>
//               <div className="col-sm-4">
//                 <label
//                   style={{
//                     fontFamily: "poppins",
//                     fontSize: "12px",
//                     color: COLORS.text,
//                   }}
//                 >
//                   Candidate Name
//                 </label>
//                 <input
//                   type="text"
//                   className="form-control form-control-sm"
//                   placeholder="Candidate Name"
//                   style={{
//                     background: COLORS.background,
//                     color: COLORS.text,
//                     border: "none",
//                   }}
//                   readOnly
//                   value={
//                     interview
//                       ? interview.candidate_name
//                       : candidateDetails.candidate_full_name || ""
//                   }
//                 />
//               </div>
//               <div className="col-sm-4">
//                 <label
//                   style={{
//                     fontFamily: "poppins",
//                     fontSize: "12px",
//                     color: COLORS.text,
//                   }}
//                 >
//                   Interview ID
//                 </label>
//                 <input
//                   type="text"
//                   className="form-control form-control-sm"
//                   placeholder="Interview ID"
//                   style={{
//                     background: COLORS.background,
//                     color: COLORS.text,
//                     border: "none",
//                   }}
//                   readOnly
//                   value={interview ? interview.interview_id : ""}
//                 />
//               </div>
//               <div className="col-sm-4">
//                 <label
//                   style={{
//                     fontFamily: "poppins",
//                     fontSize: "12px",
//                     color: COLORS.text,
//                   }}
//                 >
//                   Job Title
//                 </label>
//                 <input
//                   type="text"
//                   className="form-control form-control-sm"
//                   placeholder="Job Title"
//                   style={{
//                     background: COLORS.background,
//                     color: COLORS.text,
//                     border: "none",
//                   }}
//                   readOnly
//                   value={
//                     interview
//                       ? interview.job_title
//                       : candidateDetails.job_title || ""
//                   }
//                 />
//               </div>
//             </div>

//             {/* Round */}
//             <div className="row" style={{ margin: "2% 2%" }}>
//               <div className="col-sm-6">
//                 <label
//                   style={{
//                     fontFamily: "poppins",
//                     fontSize: "12px",
//                     color: COLORS.text,
//                   }}
//                 >
//                   Round
//                 </label>
//                 <select
//                   className="form-control form-control-sm"
//                   name="round"
//                   style={{
//                     background: COLORS.background,
//                     color: COLORS.text,
//                     border: "none",
//                   }}
//                   value={editableFields.round}
//                   onChange={handleInputChange}
//                   disabled={isReadOnly}
//                 >
//                   <option value="">Select Round</option>
//                   <option value="Technical Round 1">Technical Round 1</option>
//                   <option value="Technical Round 2">Technical Round 2</option>
//                   <option value="HR">HR</option>
//                   <option value="Managerial">Managerial</option>
//                 </select>
//               </div>

//               {/* Select Interviewer Type */}
//               <div className="col-sm-6">
//                 <label
//                   style={{
//                     fontFamily: "poppins",
//                     fontSize: "12px",
//                     color: COLORS.text,
//                   }}
//                 >
//                   Select Interviewer Type
//                 </label>
//                 <select
//                   className="form-control form-control-sm"
//                   name="select_interviewer"
//                   style={{
//                     background: COLORS.background,
//                     color: COLORS.text,
//                     border: "none",
//                   }}
//                   value={editableFields.select_interviewer}
//                   onChange={handleInputChange}
//                   disabled={isReadOnly}
//                 >
//                   <option value="">Select Interviewer Type</option>
//                   {/* <option value="Technical">Technical</option>
//                   <option value="Managerial">Managerial</option> */}
//                   <option value="Company Interviewer">Company Interviewer</option>
//                   <option value="Third Party Interviewer">
//                     Third Party Interviewer
//                   </option>
//                 </select>
//               </div>
//             </div>

//             {/* Key Notes */}
//             <div className="row" style={{ margin: "2% 2%" }}>
//               <div className="col-sm-12">
//                 <label
//                   style={{
//                     fontFamily: "poppins",
//                     fontSize: "12px",
//                     color: COLORS.text,
//                   }}
//                 >
//                   Key Notes
//                 </label>
//                 <textarea
//                   className="form-control form-control-sm"
//                   placeholder="Key Notes"
//                   name="key_notes"
//                   value={editableFields.key_notes}
//                   onChange={handleInputChange}
//                   style={{
//                     background: COLORS.background,
//                     color: COLORS.text,
//                     border: "none",
//                   }}
//                   disabled={isReadOnly}
//                   rows="3"
//                 />
//               </div>
//             </div>

//             {/* Interview Duration */}
//             <div className="row" style={{ margin: "2% 2%" }}>
//               <div className="col-sm-6">
//                 <label
//                   style={{
//                     fontFamily: "poppins",
//                     fontSize: "12px",
//                     color: COLORS.text,
//                   }}
//                 >
//                   Interview Duration (minutes)
//                 </label>
//                 <input
//                   type="number"
//                   className="form-control form-control-sm"
//                   name="interview_duration"
//                   placeholder="Duration in minutes"
//                   style={{
//                     background: COLORS.background,
//                     color: COLORS.text,
//                     border: "none",
//                   }}
//                   value={editableFields.interview_duration}
//                   onChange={handleInputChange}
//                   min="1"
//                   disabled={isReadOnly}
//                 />
//               </div>

//               {/* Organization ID - keep for now */}
//               <div className="col-sm-6">
//                 <label
//                   style={{
//                     fontFamily: "poppins",
//                     fontSize: "12px",
//                     color: COLORS.text,
//                   }}
//                 >
//                   Organization ID
//                 </label>
//                 <input
//                   type="text"
//                   className="form-control form-control-sm"
//                   placeholder="Organization ID"
//                   value={interview ? interview.organization_id : ""}
//                   style={{
//                     background: COLORS.background,
//                     color:COLORS.text,
//                     border: "none",
//                   }}
//                   readOnly
//                 />
//               </div>
//             </div>

//             {/* Date and Time Section */}
//             <div className="row" style={{ margin: "2% 2%" }}>
//               <div className="col-sm-12">
//                 <label
//                   style={{
//                     fontFamily: "poppins",
//                     fontSize: "12px",
//                     color: COLORS.text,
//                     marginBottom: "5px",
//                     display: "block",
//                   }}
//                 >
//                   Interview Date and Time
//                 </label>
//                 <div
//                   style={{
//                     display: "flex",
//                     gap: "10px",
//                     background: COLORS.background,
//                     padding: "10px",
//                     borderRadius: "4px",
//                   }}
//                 >
//                   <div style={{ flex: 1 }}>
//                     <label
//                       style={{
//                         color: COLORS.text,
//                         fontSize: "10px",
//                         marginBottom: "5px",
//                         display: "block",
//                       }}
//                     >
//                       Date
//                     </label>
//                     <DatePicker
//                       selected={selectedDate}
//                       onChange={(date) => {
//                         !isReadOnly && setSelectedDate(date);
//                         !isReadOnly && setHasChangedDate(true);
//                       }}
//                       dateFormat="yyyy/MM/dd"
//                       placeholderText="Select a date"
//                       minDate={getCurrentDateTime()}
//                       disabled={isReadOnly}
//                       style={{
//                         backgroundColor: "transparent",
//                         color: COLORS.text,
//                         border: "none",
//                         width: "100%",
//                       }}
//                       className="form-control form-control-sm"
//                       wrapperClassName="date-picker-wrapper"
//                     />
//                   </div>
//                   <div style={{ flex: 1 }}>
//                     <label
//                       style={{
//                         color: COLORS.text,
//                         fontSize: "10px",
//                         marginBottom: "5px",
//                         display: "block",
//                       }}
//                     >
//                       Time
//                     </label>
//                     <DatePicker
//                       selected={selectedTime}
//                       onChange={(time) => {
//                         !isReadOnly && setSelectedTime(time);
//                         !isReadOnly && setHasChangedTime(true);
//                       }}
//                       showTimeSelect
//                       showTimeSelectOnly
//                       timeIntervals={15}
//                       timeCaption="Time"
//                       timeFormat="HH:mm"
//                       dateFormat="HH:mm"
//                       placeholderText="Select a time"
//                       disabled={isReadOnly}
//                       style={{
//                         backgroundColor: "transparent",
//                         color: "white",
//                         border: "none",
//                         width: "100%",
//                       }}
//                       className="form-control form-control-sm"
//                       wrapperClassName="date-picker-wrapper"
//                     />
//                   </div>
//                 </div>
//                 {selectedDate && selectedTime && (
//                   <p
//                     style={{
//                       color: COLORS.text,
//                       fontSize: "12px",
//                       marginTop: "5px",
//                     }}
//                   >
//                     Selected Interview Time (IST):{" "}
//                     {new Date(
//                       selectedDate.getFullYear(),
//                       selectedDate.getMonth(),
//                       selectedDate.getDate(),
//                       selectedTime.getHours(),
//                       selectedTime.getMinutes()
//                     ).toLocaleString("en-US", {
//                       year: "numeric",
//                       month: "2-digit",
//                       day: "2-digit",
//                       hour: "2-digit",
//                       minute: "2-digit",
//                       hour12: false,
//                     })}
//                   </p>
//                 )}
//                 {isGeneratingZoom && (
//                   <p
//                     style={{
//                       color: "#007bff",
//                       fontSize: "12px",
//                       marginTop: "5px",
//                     }}
//                   >
//                     🔄 Generating Zoom meeting link...
//                   </p>
//                 )}
//               </div>
//             </div>

//             {/* Meeting Link and ID */}
//             <div className="row" style={{ margin: "2% 2%" }}>
//               <div className="col-sm-6">
//                 <label
//                   style={{
//                     fontFamily: "poppins",
//                     fontSize: "12px",
//                     color: COLORS.text,
//                   }}
//                 >
//                   Meeting Link
//                 </label>
//                 <input
//                   type="text"
//                   className="form-control form-control-sm"
//                   name="meeting_link"
//                   placeholder="Meeting Link"
//                   style={{
//                     background: COLORS.background,
//                     color: COLORS.text,
//                     border: "none",
//                   }}
//                   value={meetingLink}
//                   readOnly
//                 />
//               </div>
//               <div className="col-sm-6">
//                 <label
//                   style={{
//                     fontFamily: "poppins",
//                     fontSize: "12px",
//                     color: COLORS.text,
//                   }}
//                 >
//                   Meeting ID
//                 </label>
//                 <input
//                   type="text"
//                   className="form-control form-control-sm"
//                   placeholder="Meeting ID"
//                   style={{
//                     background: COLORS.background,
//                     color: COLORS.text,
//                     border: "none",
//                   }}
//                   value={meetingId}
//                   readOnly
//                 />
//               </div>
//             </div>

//             {/* Interviewer Selection */}
//             {editableFields.select_interviewer && (
//               <div className="row" style={{ margin: "2% 2%" }}>
//                 <div className="col-sm-12">
//                   <label
//                     style={{
//                       fontFamily: "poppins",
//                       fontSize: "12px",
//                       color: COLORS.text,
//                     }}
//                   >
//                     {editableFields.select_interviewer === "Third Party Interviewer"
//                       ? "Third Party Interviewer"
//                       : "Interviewer"}
//                   </label>

//                   {/* ── VIEW MODE: show only the selected interviewer ── */}
//                   {isReadOnly ? (
//                     <div
//                       style={{
//                         background: COLORS.background,
//                         border: `1px solid ${COLORS.border}`,
//                         borderRadius: "6px",
//                         padding: "10px 14px",
//                         marginTop: "6px",
//                       }}
//                     >
//                       {editableFields.select_interviewer === "Third Party Interviewer" ? (
//                         (() => {
//                           const tp = tpInterviewers.find(
//                             (i) => i.user_id === (selectedTpInterviewer || editableFields.interview_panel)
//                           );
//                           return tp ? (
//                             <span style={{ color: COLORS.text, fontSize: "13px" }}>
//                               <strong>{tp.name}</strong> &nbsp;|&nbsp; {tp.email} &nbsp;|&nbsp; {tp.mobile}
//                             </span>
//                           ) : (
//                             <span style={{ color: COLORS.textSecondary, fontSize: "13px" }}>
//                               {editableFields.interview_panel || "No interviewer selected"}
//                             </span>
//                           );
//                         })()
//                       ) : (
//                         (() => {
//                           const allInterviewers = [...technologists, ...managers, ...hrs];
//                           const selected = allInterviewers.find(
//                             (i) => i.panelist_id === editableFields.interview_panel
//                           );
//                           return selected ? (
//                             <span style={{ color: COLORS.text, fontSize: "13px" }}>
//                               <strong>{selected.full_name}</strong> &nbsp;|&nbsp;
//                               {selected.official_email_id || "N/A"} &nbsp;|&nbsp;
//                               {selected.designation || "N/A"}
//                             </span>
//                           ) : (
//                             <span style={{ color: COLORS.textSecondary, fontSize: "13px" }}>
//                               {editableFields.interview_panel || "No interviewer selected"}
//                             </span>
//                           );
//                         })()
//                       )}
//                     </div>

//                   ) : (
//                     /* ── EDIT MODE: show full table filtered by round + type ── */
//                     <>
//                       {!editableFields.round || !editableFields.select_interviewer ? (
//                         <p style={{ color: COLORS.textSecondary, fontSize: "12px", marginTop: "8px" }}>
//                           Please select a Round and Interviewer Type first.
//                         </p>
//                       ) : editableFields.select_interviewer === "Third Party Interviewer" ? (
//                         <>
//                           <TableContainer
//                             component={Paper}
//                             style={{ marginTop: "10px", borderRadius: "10px", maxHeight: "300px", overflow: "auto" }}
//                           >
//                             <Table size="small">
//                               <TableHead style={{ background: COLORS.accent }}>
//                                 <TableRow>
//                                   <TableCell style={{ color: "#fff", fontWeight: 600 }}>Name</TableCell>
//                                   <TableCell style={{ color: "#fff", fontWeight: 600 }}>Email</TableCell>
//                                   <TableCell style={{ color: "#fff", fontWeight: 600 }}>Mobile</TableCell>
//                                   <TableCell style={{ color: "#fff", fontWeight: 600 }}>Status</TableCell>
//                                   <TableCell style={{ color: "#fff", fontWeight: 600 }}>Action</TableCell>
//                                 </TableRow>
//                               </TableHead>
//                               <TableBody>
//                                 {tpInterviewers.map((tp) => (
//                                   <TableRow key={tp.user_id} style={{ background: COLORS.background }}>
//                                     <TableCell style={{ color: COLORS.text, border: `1px solid ${COLORS.border}` }}>{tp.name}</TableCell>
//                                     <TableCell style={{ color: COLORS.text, border: `1px solid ${COLORS.border}` }}>{tp.email}</TableCell>
//                                     <TableCell style={{ color: COLORS.text, border: `1px solid ${COLORS.border}` }}>{tp.mobile}</TableCell>
//                                     <TableCell style={{ color: COLORS.text, border: `1px solid ${COLORS.border}` }}>{tp.activation_status}</TableCell>
//                                     <TableCell style={{ color: COLORS.text, border: `1px solid ${COLORS.border}` }}>
//                                       <Button
//                                         variant="contained"
//                                         size="small"
//                                         onClick={() => handleSelectTpInterviewer(tp.user_id)}
//                                         style={{
//                                           background: selectedTpInterviewer === tp.user_id ? COLORS.accent : COLORS.button_edit_bg,
//                                           color: COLORS.text,
//                                           fontFamily: "Poppins",
//                                           textTransform: "none",
//                                           fontWeight: selectedTpInterviewer === tp.user_id ? 700 : 500,
//                                         }}
//                                       >
//                                         {selectedTpInterviewer === tp.user_id ? "Selected ✓" : "Select"}
//                                       </Button>
//                                     </TableCell>
//                                   </TableRow>
//                                 ))}
//                               </TableBody>
//                             </Table>
//                           </TableContainer>
//                           {selectedTpInterviewer && (
//                             <p style={{ color: COLORS.accent, fontSize: "12px", marginTop: "8px" }}>
//                               ✓ Selected: {tpInterviewers.find((i) => i.user_id === selectedTpInterviewer)?.name} ({selectedTpInterviewer})
//                             </p>
//                           )}
//                         </>
//                       ) : (
//                         <>
//                           {interviewerList.length === 0 ? (
//                             <p style={{ color: COLORS.textSecondary, fontSize: "12px", marginTop: "8px" }}>
//                               No interviewers found for the selected round and type.
//                             </p>
//                           ) : (
//                             <TableContainer
//                               component={Paper}
//                               style={{ marginTop: "10px", borderRadius: "10px", maxHeight: "300px", overflow: "auto" }}
//                             >
//                               <Table size="small">
//                                 <TableHead style={{ background: COLORS.accent }}>
//                                   <TableRow>
//                                     <TableCell style={{ color: "#fff", fontWeight: 600 }}>Name</TableCell>
//                                     <TableCell style={{ color: "#fff", fontWeight: 600 }}>Email</TableCell>
//                                     <TableCell style={{ color: "#fff", fontWeight: 600 }}>Skills</TableCell>
//                                     <TableCell style={{ color: "#fff", fontWeight: 600 }}>Designation</TableCell>
//                                     <TableCell style={{ color: "#fff", fontWeight: 600 }}>Action</TableCell>
//                                   </TableRow>
//                                 </TableHead>
//                                 <TableBody>
//                                   {interviewerList.map((interviewer) => (
//                                     <TableRow key={interviewer.panelist_id} style={{ background: COLORS.background }}>
//                                       <TableCell style={{ color: COLORS.text, border: `1px solid ${COLORS.border}` }}>{interviewer.full_name}</TableCell>
//                                       <TableCell style={{ color: COLORS.text, border: `1px solid ${COLORS.border}` }}>{interviewer.official_email_id || "N/A"}</TableCell>
//                                       <TableCell style={{ color: COLORS.text, border: `1px solid ${COLORS.border}` }}>
//                                         {Array.isArray(interviewer.skills) ? interviewer.skills.join(", ") : interviewer.skills || "N/A"}
//                                       </TableCell>
//                                       <TableCell style={{ color: COLORS.text, border: `1px solid ${COLORS.border}` }}>{interviewer.designation || "N/A"}</TableCell>
//                                       <TableCell style={{ color: COLORS.text, border: `1px solid ${COLORS.border}` }}>
//                                         <Button
//                                           variant="contained"
//                                           size="small"
//                                           onClick={() => handleSelectInterviewer(interviewer.panelist_id)}
//                                           style={{
//                                             background: editableFields.interview_panel === interviewer.panelist_id ? COLORS.accent : COLORS.button_edit_bg,
//                                             color: COLORS.text,
//                                             fontFamily: "Poppins",
//                                             textTransform: "none",
//                                             fontWeight: editableFields.interview_panel === interviewer.panelist_id ? 700 : 500,
//                                           }}
//                                         >
//                                           {editableFields.interview_panel === interviewer.panelist_id ? "Selected ✓" : "Select"}
//                                         </Button>
//                                       </TableCell>
//                                     </TableRow>
//                                   ))}
//                                 </TableBody>
//                               </Table>
//                             </TableContainer>
//                           )}
//                           {editableFields.interview_panel && (
//                             <p style={{ color: COLORS.accent, fontSize: "12px", marginTop: "8px" }}>
//                               ✓ Selected: {interviewerList.find((i) => i.panelist_id === editableFields.interview_panel)?.full_name} ({editableFields.interview_panel})
//                             </p>
//                           )}
//                         </>
//                       )}
//                     </>
//                   )}
//                 </div>
//               </div>
//             )}

//             {/* Reschedule */}
//             <div className="row" style={{ margin: "2% 2%" }}>
//               <div className="col-sm-6">
//                 <label
//                   style={{
//                     fontFamily: "poppins",
//                     fontSize: "12px",
//                     color: COLORS.text,
//                   }}
//                 >
//                   Reschedule
//                 </label>
//                 <select
//                   className="form-control form-control-sm"
//                   name="reschedule"
//                   style={{
//                     background: COLORS.background,
//                     color: COLORS.text,
//                     border: "none",
//                   }}
//                   value={editableFields.reschedule}
//                   onChange={handleInputChange}
//                   disabled={isReadOnly}
//                 >
//                   <option value="Yes">Yes</option>
//                   <option value="No">No</option>
//                 </select>
//               </div>
//             </div>

//             {/* Buttons */}
//             {!isReadOnly && (
//               <div className="row" style={{ margin: "4% 2% 2% 2%" }}>
//                 <div className="col-sm-6">
//                   <button
//                     type="button"
//                     className="btn btn-sm rounded-2 fw-medium"
//                     onClick={handleReset}
//                     style={{
//                       margin: "0",
//                       color: COLORS.background,
//                       width: "100%",
//                       border: "1px solid #1E1E1E",
//                       backgroundColor: COLORS.button,
//                       cursor: "pointer",
//                     }}
//                   >
//                     Reset
//                   </button>
//                 </div>
//                 <div className="col-sm-6">
//                   <button
//                     type="button"
//                     className="btn btn-sm rounded-2 fw-medium"
//                     onClick={handleSubmit}
//                     style={{
//                       margin: "0",
//                       color: COLORS.background,
//                       width: "100%",
//                       border: "1px solid #1E1E1E",
//                       background: COLORS.button_green_bg,
//                       cursor: "pointer",
//                     }}
//                   >
//                     Submit
//                   </button>
//                 </div>
//               </div>
//             )}
//           </div>
//           <style>{`
                                    
//   /* Input field */
//              .react-datepicker__header{
//              background-color: ${COLORS.accent} !important },

//             .date-picker-wrapper .react-datepicker__input-container input {
//               color: ${COLORS.text} !important;
//               background-color: transparent !important;
//             }
//             .date-picker-wrapper .react-datepicker__input-container input:disabled {
//               color: #cccccc !important;
//               background-color: transparent !important;
//               opacity: 1 !important;
//             }
//             .date-picker-wrapper .react-datepicker__input-container input::placeholder {
//               color: #888888 !important;
//             }
 
//             /* === CALENDAR POPUP === */
//             .react-datepicker,
//             .react-datepicker__month-container {
//               background-color: ${COLORS.primary} !important;
//               border: 1px solid ${COLORS.border} !important;
//               color: ${COLORS.text} !important;
//               font-family: Poppins, sans-serif !important;
//             }
 
//             /* Header - THIS is what was green */
//             .react-datepicker__header,
//             .react-datepicker__header--time,
//             .react-datepicker-time__header {
//               background-color: ${COLORS.secondary} !important;
//               border-bottom: 1px solid ${COLORS.border} !important;
//               color: ${COLORS.text} !important;
//             }
 
//             .react-datepicker__current-month,
//             .react-datepicker__day-name,
//             .react-datepicker-time__header {
//               color: ${COLORS.text} !important;
//             }
 
//             /* Navigation arrows */
//             .react-datepicker__navigation-icon::before {
//               border-color: ${COLORS.text} !important;
//             }
//             .react-datepicker__navigation:hover *::before {
//               border-color: ${COLORS.accent} !important;
//             }
 
//             /* Day cells */
//             .react-datepicker__day,
//             .react-datepicker__day--outside-month {
//               color: ${COLORS.text} !important;
//             }
//             .react-datepicker__day:hover {
//               background-color: ${COLORS.hoverBg} !important;
//               color: ${COLORS.accent} !important;
//               border-radius: 50% !important;
//             }
 
//             /* Selected day */
//             .react-datepicker__day--selected,
//             .react-datepicker__day--keyboard-selected {
//               background-color: ${COLORS.accent} !important;
//               color: #fff !important;
//               border-radius: 50% !important;
//             }
 
//             /* Today */
//             .react-datepicker__day--today {
//               font-weight: bold !important;
//               color: ${COLORS.accent} !important;
//             }
 
//             /* Disabled days */
//             .react-datepicker__day--disabled {
//               color: #555555 !important;
//               cursor: not-allowed !important;
//             }
//             .react-datepicker__day--disabled:hover {
//               background-color: transparent !important;
//               color: #555555 !important;
//             }
 
//             /* === TIME PICKER === */
//             .react-datepicker__time-container {
//               border-left: 1px solid ${COLORS.border} !important;
//             }
//             .react-datepicker__time-container .react-datepicker__time,
//             .react-datepicker__time-container .react-datepicker__time-box {
//               background-color: ${COLORS.primary} !important;
//             }
//             .react-datepicker__time-container .react-datepicker__time-list-item {
//               color: ${COLORS.text} !important;
//               background-color: ${COLORS.primary} !important;
//             }
//             .react-datepicker__time-container .react-datepicker__time-list-item:hover {
//               background-color: ${COLORS.hoverBg} !important;
//               color: ${COLORS.accent} !important;
//             }
//             .react-datepicker__time-container .react-datepicker__time-list-item--selected {
//               background-color: ${COLORS.accent} !important;
//               color: #ffffff !important;
//             }
//             .react-datepicker__time-container .react-datepicker__time-list-item--selected:hover {
//               background-color: ${COLORS.accent} !important;
//               color: #ffffff !important;
//             }
 
//             /* Triangle pointer */
//             .react-datepicker__triangle::before {
//               border-bottom-color: ${COLORS.border} !important;
//               border-top-color: ${COLORS.border} !important;
//             }
//             .react-datepicker__triangle::after {
//               border-bottom-color: ${COLORS.secondary} !important;
//               border-top-color: ${COLORS.secondary} !important;
//             }















          

//           `}</style>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ViewModal;

































































import React, { useState, useEffect } from "react";
import createInstance from "../../../api/axiosinstance";
import { toast } from "react-toastify";
import Loader from "../../Loader";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useSelector } from "react-redux";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
} from "@mui/material";
import { useThemeMode } from "../../Themes/ThemeContextTemp.js";
import { Autocomplete, TextField } from "@mui/material";

const ViewModal = ({
  isOpen,
  onClose,
  title,
  feedback,
  rating,
  candidateId,
  interview,
  onUpdate,
  isReadOnly,
}) => {
  const aiDishaApi = createInstance("DISHA");
  const { COLORS, theme, toggleTheme } = useThemeMode();
  const [candidateDetails, setCandidateDetails] = useState({});
  const [editableFields, setEditableFields] = useState({
    interview_panel: [],
    meeting_link: "",
    round: "",
    interview_duration: "",
    reschedule: "Yes",
    key_notes: "",
    select_interviewer: "",
  });
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedTime, setSelectedTime] = useState(null);
  const [meetingLink, setMeetingLink] = useState("");
  const [meetingId, setMeetingId] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isGeneratingZoom, setIsGeneratingZoom] = useState(false);
  const [technologists, setTechnologists] = useState([]);
  const [managers, setManagers] = useState([]);
  const [hrs, setHrs] = useState([]);
  const [interviewerList, setInterviewerList] = useState([]);
  const [tpInterviewers, setTpInterviewers] = useState([]);
  const [selectedTpInterviewer, setSelectedTpInterviewer] = useState([]);
  const [hasChangedDate, setHasChangedDate] = useState(false);
  const [hasChangedTime, setHasChangedTime] = useState(false);
  const [ccEmails, setCcEmails] = useState([]);
  const { user } = useSelector((state) => state.auth);
  const organizationId = user?.organizationId;
  const hrId = user?.orgUserId;

  const getCurrentDateTime = () => {
    const now = new Date();
    return now;
  };

  useEffect(() => {
    if (candidateId) {
      getCandidateDetails();
    }
  }, [candidateId]);

  useEffect(() => {
    if (isOpen) {
      getInterviewers();
      getAllTpInterviewers();
    }
  }, [isOpen]);

  useEffect(() => {
    if (editableFields.round && editableFields.select_interviewer) {
      updateInterviewerList(
        editableFields.round,
        editableFields.select_interviewer
      );
    }
  }, [
    editableFields.round,
    editableFields.select_interviewer,
    technologists,
    managers,
    hrs,
  ]);

  const updateInterviewerList = (round, selectInterviewer) => {
    if (!round || !selectInterviewer) {
      setInterviewerList([]);
      return;
    }
    if (selectInterviewer === "Third Party Interviewer") {
      setInterviewerList([]);
      return;
    }
    if (round === "Technical Round 1" || round === "Technical Round 2") {
      setInterviewerList(technologists);
    } else if (round === "Managerial") {
      setInterviewerList(managers);
    } else if (round === "HR") {
      setInterviewerList(hrs);
    } else {
      setInterviewerList([]);
    }
  };

  const getInterviewers = async () => {
    setIsLoading(true);
    try {
      const response = await aiDishaApi.get(
        `/get_interviewers?org_id=${organizationId}`
      );
      const interviewers = response.data;
      setTechnologists(interviewers["Technical"] || []);
      setHrs(interviewers["HR"] || []);
      setManagers(interviewers["Managerial"] || []);
      if (editableFields.round && editableFields.select_interviewer) {
        updateInterviewerList(
          editableFields.round,
          editableFields.select_interviewer
        );
      }
    } catch (error) {
      console.log("Error fetching interviewers", error);
      toast.error("Failed to fetch interviewers list");
    } finally {
      setIsLoading(false);
    }
  };

  const getAllTpInterviewers = async () => {
    try {
      const response = await aiDishaApi.get("/get-all-interviewer");
      const users = response.data["active_users"] || [];
      setTpInterviewers(users.filter((u) => u.role === "TP-Interviewer"));
    } catch (error) {
      console.error("Error fetching TP interviewers:", error);
      toast.error("Failed to fetch TP Interviewers. Please try again.");
    }
  };

  const getCandidateDetails = async () => {
    if (!candidateId) return;
    await aiDishaApi
      .get(`/get-candidates-by-candidate-id?candidate_id=${candidateId}`)
      .then((response) => {
        setCandidateDetails(response.data);
      })
      .catch((error) => {
        console.log("Error fetching candidate performance details", error);
      });
  };

  // Auto-generate Zoom link only when both date and time are user-changed
  useEffect(() => {
    const generateZoomLink = async () => {
      if (
        !isReadOnly &&
        selectedDate &&
        selectedTime &&
        hasChangedDate &&
        hasChangedTime
      ) {
        setIsGeneratingZoom(true);
        try {
          const formattedDate = `${selectedDate.getFullYear()}-${String(
            selectedDate.getMonth() + 1
          ).padStart(2, "0")}-${String(selectedDate.getDate()).padStart(
            2,
            "0"
          )}`;
          const formattedTime = `${String(selectedTime.getHours()).padStart(
            2,
            "0"
          )}:${String(selectedTime.getMinutes()).padStart(2, "0")}`;
          const response = await aiDishaApi.post("/zoom-meeting-creator/", {
            date: formattedDate,
            time: formattedTime,
          });
          setMeetingLink(response.data["Join URL"]);
          setMeetingId(String(response.data["Meeting ID"]));
          toast.success("Zoom meeting link generated successfully");
          setEditableFields((prev) => ({
            ...prev,
            meeting_link: response.data["Join URL"],
          }));
        } catch (error) {
          console.error("Error generating Zoom link:", error);
          toast.error("Failed to generate Zoom meeting link");
          setMeetingLink("");
          setMeetingId("");
          setEditableFields((prev) => ({ ...prev, meeting_link: "" }));
        } finally {
          setIsGeneratingZoom(false);
        }
      } else {
        if (selectedDate && selectedTime) {
          setMeetingLink(interview?.meeting_link || "");
          setMeetingId(interview?.zoom_meeting_id || "");
          setEditableFields((prev) => ({
            ...prev,
            meeting_link: interview?.meeting_link || "",
          }));
        } else {
          setMeetingLink("");
          setMeetingId("");
          setEditableFields((prev) => ({ ...prev, meeting_link: "" }));
        }
      }
    };
    generateZoomLink();
  }, [
    selectedDate,
    selectedTime,
    hasChangedDate,
    hasChangedTime,
    isReadOnly,
    interview,
  ]);

  useEffect(() => {
    if (isOpen && interview) {
      let dateObj = null;
      let timeObj = null;
      let dateTimeField =
        interview.round === "Technical Round 2"
          ? interview["Technical Round 2 interview_date_and_time"] ||
            interview.interview_date_and_time
          : interview.interview_date_and_time;
      if (dateTimeField) {
        try {
          const parsedDate =
            dateTimeField.includes("Z") || dateTimeField.includes("+")
              ? new Date(dateTimeField)
              : new Date(dateTimeField + "Z");
          if (!isNaN(parsedDate.getTime())) {
            const istDate = new Date(
              parsedDate.getTime() + 5.5 * 60 * 60 * 1000
            );
            dateObj = new Date(
              istDate.getFullYear(),
              istDate.getMonth(),
              istDate.getDate()
            );
            timeObj = new Date(istDate.getTime());
            setSelectedDate(dateObj);
            setSelectedTime(timeObj);
            setCcEmails(interview.cc_emails || []);
          } else {
            console.error("Invalid interview date:", dateTimeField);
            setSelectedDate(null);
            setSelectedTime(null);
          }
        } catch (e) {
          console.error("Error parsing date:", e);
          setSelectedDate(null);
          setSelectedTime(null);
        }
      } else {
        setSelectedDate(null);
        setSelectedTime(null);
      }

      setMeetingLink(interview.meeting_link || "");
      setMeetingId(interview.zoom_meeting_id || "");

      const panelArray = Array.isArray(interview.interview_panel)
        ? interview.interview_panel
        : interview.interview_panel
        ? [interview.interview_panel]
        : [];

      setEditableFields({
        interview_panel: panelArray,
        meeting_link: interview.meeting_link || "",
        round: interview.round || "",
        interview_duration: interview.interview_duration || "",
        reschedule: interview.Reschedule || "Yes",
        key_notes: interview.key_notes || interview.keynotes || "",
        select_interviewer: interview.select_interviewer || "",
      });

      if (
        interview.select_interviewer === "Third Party Interviewer" &&
        interview.interview_panel
      ) {
        setSelectedTpInterviewer(panelArray);
      }

      if (interview.round && interview.select_interviewer) {
        updateInterviewerList(interview.round, interview.select_interviewer);
      }
    }
  }, [isOpen, interview]);

  const handleClose = () => {
    setCandidateDetails({});
    setSelectedDate(null);
    setSelectedTime(null);
    setMeetingLink("");
    setMeetingId("");
    setHasChangedDate(false);
    setHasChangedTime(false);
    setEditableFields({
      interview_panel: [],
      meeting_link: "",
      round: "",
      interview_duration: "",
      reschedule: "Yes",
      key_notes: "",
      select_interviewer: "",
    });
    setSelectedTpInterviewer([]);
    onClose();
  };

  const handleInputChange = (e) => {
    if (isReadOnly) return;
    const { name, value } = e.target;
    setEditableFields((prev) => ({
      ...prev,
      [name]: value,
      ...(name === "round" || name === "select_interviewer"
        ? { interview_panel: [] }
        : {}),
    }));
    if (name === "round" || name === "select_interviewer") {
      setSelectedTpInterviewer([]);
    }
  };

  const handleSelectInterviewer = (panelist_id) => {
    if (isReadOnly) return;
    setEditableFields((prev) => ({
      ...prev,
      interview_panel: prev.interview_panel.includes(panelist_id)
        ? prev.interview_panel.filter((id) => id !== panelist_id)
        : [...prev.interview_panel, panelist_id],
    }));
  };

  const handleSelectTpInterviewer = (user_id) => {
    if (isReadOnly) return;
    setSelectedTpInterviewer((prev) => {
      const updated = prev.includes(user_id)
        ? prev.filter((id) => id !== user_id)
        : [...prev, user_id];
      setEditableFields((prevFields) => ({
        ...prevFields,
        interview_panel: updated,
      }));
      return updated;
    });
  };

  const validateForm = () => {
    if (isReadOnly) return true;
    if (!candidateId.trim()) {
      toast.error("Candidate ID cannot be empty");
      return false;
    }
    if (!editableFields.round.trim()) {
      toast.error("Round cannot be empty");
      return false;
    }
    if (!editableFields.select_interviewer.trim()) {
      toast.error("Select Interviewer Type cannot be empty");
      return false;
    }
    if (!editableFields.key_notes.trim()) {
      toast.error("Key notes cannot be empty");
      return false;
    }
    const selectedPanel =
      editableFields.select_interviewer === "Third Party Interviewer"
        ? selectedTpInterviewer
        : editableFields.interview_panel;
    if (!selectedPanel || selectedPanel.length === 0) {
      toast.error("Please select at least one Interviewer");
      return false;
    }
    if (!selectedDate || !selectedTime) {
      toast.error("Interview Date and Time cannot be empty");
      return false;
    }
    if (!meetingLink.trim()) {
      toast.error(
        "Meeting Link cannot be empty. Please select date and time first."
      );
      return false;
    }
    if (!meetingId.trim()) {
      toast.error(
        "Meeting ID cannot be empty. Please select date and time first."
      );
      return false;
    }
    if (
      !editableFields.interview_duration.trim() ||
      isNaN(editableFields.interview_duration) ||
      editableFields.interview_duration <= 0
    ) {
      toast.error("Please enter a valid interview duration in minutes");
      return false;
    }
    const combinedDateTime = new Date(
      selectedDate.getFullYear(),
      selectedDate.getMonth(),
      selectedDate.getDate(),
      selectedTime.getHours(),
      selectedTime.getMinutes()
    );
    const now = new Date();
    if (combinedDateTime <= now) {
      toast.error("Please select a future date and time");
      return false;
    }
    return true;
  };

  const handleReset = () => {
    if (isReadOnly) return;
    if (interview) {
      let dateObj = null;
      let timeObj = null;
      let dateTimeField =
        interview.round === "Technical Round 2"
          ? interview["Technical Round 2 interview_date_and_time"] ||
            interview.interview_date_and_time
          : interview.interview_date_and_time;
      if (dateTimeField) {
        try {
          const parsedDate =
            dateTimeField.includes("Z") || dateTimeField.includes("+")
              ? new Date(dateTimeField)
              : new Date(dateTimeField + "Z");
          if (!isNaN(parsedDate.getTime())) {
            const istDate = new Date(
              parsedDate.getTime() + 5.5 * 60 * 60 * 1000
            );
            dateObj = new Date(
              istDate.getFullYear(),
              istDate.getMonth(),
              istDate.getDate()
            );
            timeObj = new Date(istDate.getTime());
            setSelectedDate(dateObj);
            setSelectedTime(timeObj);
            setCcEmails(interview.cc_emails || []);
          } else {
            setSelectedDate(null);
            setSelectedTime(null);
          }
        } catch (e) {
          console.error("Error parsing date on reset:", e);
          setSelectedDate(null);
          setSelectedTime(null);
        }
      } else {
        setSelectedDate(null);
        setSelectedTime(null);
      }

      setMeetingLink(interview.meeting_link || "");
      setMeetingId(interview.zoom_meeting_id || "");

      const panelArray = Array.isArray(interview.interview_panel)
        ? interview.interview_panel
        : interview.interview_panel
        ? [interview.interview_panel]
        : [];

      setEditableFields({
        interview_panel: panelArray,
        meeting_link: interview.meeting_link || "",
        round: interview.round || "",
        interview_duration: interview.interview_duration || "",
        reschedule: interview.Reschedule || "Yes",
        key_notes: interview.key_notes || interview.keynotes || "",
        select_interviewer: interview.select_interviewer || "",
      });

      if (
        interview.select_interviewer === "Third Party Interviewer" &&
        interview.interview_panel
      ) {
        setSelectedTpInterviewer(panelArray);
      }

      if (interview.round && interview.select_interviewer) {
        updateInterviewerList(interview.round, interview.select_interviewer);
      }

      setHasChangedDate(false);
      setHasChangedTime(false);
    }
  };

  const handleSubmit = async () => {
    if (isReadOnly) return;
    if (!validateForm()) return;
    if (!interview) return;
    setIsLoading(true);
    try {
      const combinedDateTime = new Date(
        selectedDate.getFullYear(),
        selectedDate.getMonth(),
        selectedDate.getDate(),
        selectedTime.getHours(),
        selectedTime.getMinutes(),
        0
      );
      const utcDateTime = new Date(
        combinedDateTime.getTime() - 5.5 * 60 * 60 * 1000
      );
      const formattedDateTime = utcDateTime.toISOString();

      const selectedPanel =
        editableFields.select_interviewer === "Third Party Interviewer"
          ? selectedTpInterviewer
          : editableFields.interview_panel;

      const params = new URLSearchParams();
      params.append("interview_id", interview.interview_id);
      params.append("organization_id", organizationId);
      params.append("Hr_id", hrId);
      params.append("candidate_id", interview.candidate_id);
      params.append("candidate_name", interview.candidate_name);
      params.append("job_title", interview.job_title);
      selectedPanel.forEach((id) => params.append("Interview_panel", id));
      params.append("link", meetingLink);
      params.append("zoom_meeting_id", meetingId);
      params.append("round", editableFields.round);
      params.append("select_interviewer", editableFields.select_interviewer);
      params.append("Key_notes", editableFields.key_notes);
      params.append("interview_duration", editableFields.interview_duration);
      params.append("Reschedule", editableFields.reschedule);
      ccEmails.forEach((email) => {
        params.append("cc_emails", email);
      });

      const url = `/update_interview?${params.toString()}`;
      const requestBody = {
        status: "Active",
        interview_date_and_time: formattedDateTime,
      };

      const response = await aiDishaApi.put(url, requestBody);
      toast.success("Interview updated successfully");
      if (onUpdate) onUpdate();
      handleClose();
    } catch (error) {
      console.error("Error updating interview:", error);
      toast.error(
        "Failed to update interview: " + (error.message || "Unknown error")
      );
    } finally {
      setIsLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div
      className={`modal fade ${isOpen ? "show" : ""}`}
      tabIndex="-1"
      style={{
        display: isOpen ? "block" : "none",
        backgroundColor: "rgba(0,0,0,0.5)",
        zIndex: 1050,
        position: "fixed",
        top: 40,
        left: 140,
        width: "100vw",
        height: "100vh",
      }}
    >
      <div
        className="modal-dialog modal-xl modal-dialog-centered view-modal-shift"
        style={{ margin: "auto !important" }}
      >
        <div
          className="modal-content"
          style={{ background: COLORS.primary, position: "relative" }}
        >
          {(isLoading || isGeneratingZoom) && (
            <>
              <div
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  backgroundColor: "rgba(0, 0, 0, 0.5)",
                  zIndex: 999,
                }}
              />
              <div
                style={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  zIndex: 1000,
                }}
              >
                <Loader />
              </div>
            </>
          )}
          <div className="modal-header border-0">
            <label style={{ color: COLORS.text, fontSize: "18px" }}>
              {title || "Candidate Performance"}
            </label>
            <button
              type="button"
              className="btn-close"
              onClick={handleClose}
            ></button>
          </div>
          <div
            style={{
              padding: "20px",
              height: "calc(100vh - 200px)",
              overflowY: "auto",
            }}
          >
            {/* Candidate Info Row */}
            <div className="row" style={{ margin: "0% 2%" }}>
              <div className="col-sm-4">
                <label style={{ fontFamily: "poppins", fontSize: "12px", color: COLORS.text }}>
                  Candidate Name
                </label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  placeholder="Candidate Name"
                  style={{ background: COLORS.background, color: COLORS.text, border: "none" }}
                  readOnly
                  value={interview ? interview.candidate_name : candidateDetails.candidate_full_name || ""}
                />
              </div>
              <div className="col-sm-4">
                <label style={{ fontFamily: "poppins", fontSize: "12px", color: COLORS.text }}>
                  Interview ID
                </label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  placeholder="Interview ID"
                  style={{ background: COLORS.background, color: COLORS.text, border: "none" }}
                  readOnly
                  value={interview ? interview.interview_id : ""}
                />
              </div>
              <div className="col-sm-4">
                <label style={{ fontFamily: "poppins", fontSize: "12px", color: COLORS.text }}>
                  Job Title
                </label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  placeholder="Job Title"
                  style={{ background: COLORS.background, color: COLORS.text, border: "none" }}
                  readOnly
                  value={interview ? interview.job_title : candidateDetails.job_title || ""}
                />
              </div>
            </div>

            {/* Round */}
            <div className="row" style={{ margin: "2% 2%" }}>
              <div className="col-sm-6">
                <label style={{ fontFamily: "poppins", fontSize: "12px", color: COLORS.text }}>
                  Round
                </label>
                <select
                  className="form-control form-control-sm"
                  name="round"
                  style={{ background: COLORS.background, color: COLORS.text, border: "none" }}
                  value={editableFields.round}
                  onChange={handleInputChange}
                  disabled={isReadOnly}
                >
                  <option value="">Select Round</option>
                  <option value="Technical Round 1">Technical Round 1</option>
                  <option value="Technical Round 2">Technical Round 2</option>
                  <option value="HR">HR</option>
                  <option value="Managerial">Managerial</option>
                </select>
              </div>

              <div className="col-sm-6">
                <label style={{ fontFamily: "poppins", fontSize: "12px", color: COLORS.text }}>
                  Select Interviewer Type
                </label>
                <select
                  className="form-control form-control-sm"
                  name="select_interviewer"
                  style={{ background: COLORS.background, color: COLORS.text, border: "none" }}
                  value={editableFields.select_interviewer}
                  onChange={handleInputChange}
                  disabled={isReadOnly}
                >
                  <option value="">Select Interviewer Type</option>
                  <option value="Company Interviewers">Company Interviewers</option>
                  <option value="Third Party Interviewer">Third Party Interviewer</option>
                </select>
              </div>
            </div>

            {/* Key Notes */}
            <div className="row" style={{ margin: "2% 2%" }}>
              <div className="col-sm-12">
                <label style={{ fontFamily: "poppins", fontSize: "12px", color: COLORS.text }}>
                  Key Notes
                </label>
                <textarea
                  className="form-control form-control-sm"
                  placeholder="Key Notes"
                  name="key_notes"
                  value={editableFields.key_notes}
                  onChange={handleInputChange}
                  style={{ background: COLORS.background, color: COLORS.text, border: "none" }}
                  disabled={isReadOnly}
                  rows="3"
                />
              </div>
            </div>

            {/* Interview Duration */}
            <div className="row" style={{ margin: "2% 2%" }}>
              <div className="col-sm-6">
                <label style={{ fontFamily: "poppins", fontSize: "12px", color: COLORS.text }}>
                  Interview Duration (minutes)
                </label>
                <input
                  type="number"
                  className="form-control form-control-sm"
                  name="interview_duration"
                  placeholder="Duration in minutes"
                  style={{ background: COLORS.background, color: COLORS.text, border: "none" }}
                  value={editableFields.interview_duration}
                  onChange={handleInputChange}
                  min="1"
                  disabled={isReadOnly}
                />
              </div>
              <div className="col-sm-6">
                <label style={{ fontFamily: "poppins", fontSize: "12px", color: COLORS.text }}>
                  Organization ID
                </label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  placeholder="Organization ID"
                  value={interview ? interview.organization_id : ""}
                  style={{ background: COLORS.background, color: COLORS.text, border: "none" }}
                  readOnly
                />
              </div>
            </div>





























<div className="row" style={{ margin: "2% 2%" }}>
  <div className="col-sm-12">
    <label style={{ fontFamily: "poppins", fontSize: "12px", color: COLORS.text }}>
      CC Emails (Optional)
    </label>

    <Autocomplete
      multiple
      freeSolo
      options={[]}
      value={ccEmails}
      onChange={(event, newValue) => setCcEmails(newValue)}
      renderInput={(params) => (
        <TextField
          {...params}
          placeholder="Enter email and press Enter"
          size="small"
          sx={{ background: COLORS.background }}


          onBlur={(e) => {
  const value = e.target.value.trim();
  if (value && !ccEmails.includes(value)) {
    setCcEmails((prev) => [...prev, value]);
  }
}}
        />
      )}
    />
  </div>
</div>
















            {/* Date and Time Section */}
            <div className="row" style={{ margin: "2% 2%" }}>
              <div className="col-sm-12">
                <label style={{ fontFamily: "poppins", fontSize: "12px", color: COLORS.text, marginBottom: "5px", display: "block" }}>
                  Interview Date and Time
                </label>
                <div style={{ display: "flex", gap: "10px", background: COLORS.background, padding: "10px", borderRadius: "4px" }}>
                  <div style={{ flex: 1 }}>
                    <label style={{ color: COLORS.text, fontSize: "10px", marginBottom: "5px", display: "block" }}>
                      Date
                    </label>
                    <DatePicker
                      selected={selectedDate}
                      onChange={(date) => {
                        !isReadOnly && setSelectedDate(date);
                        !isReadOnly && setHasChangedDate(true);
                      }}
                      dateFormat="yyyy/MM/dd"
                      placeholderText="Select a date"
                      minDate={getCurrentDateTime()}
                      disabled={isReadOnly}
                      className="form-control form-control-sm"
                      wrapperClassName="date-picker-wrapper"
                    />
                  </div>
                  <div style={{ flex: 1 }}>
                    <label style={{ color: COLORS.text, fontSize: "10px", marginBottom: "5px", display: "block" }}>
                      Time
                    </label>
                    <DatePicker
                      selected={selectedTime}
                      onChange={(time) => {
                        !isReadOnly && setSelectedTime(time);
                        !isReadOnly && setHasChangedTime(true);
                      }}
                      showTimeSelect
                      showTimeSelectOnly
                      timeIntervals={15}
                      timeCaption="Time"
                      timeFormat="HH:mm"
                      dateFormat="HH:mm"
                      placeholderText="Select a time"
                      disabled={isReadOnly}
                      className="form-control form-control-sm"
                      wrapperClassName="date-picker-wrapper"
                    />
                  </div>
                </div>
                {selectedDate && selectedTime && (
                  <p style={{ color: COLORS.text, fontSize: "12px", marginTop: "5px" }}>
                    Selected Interview Time (IST):{" "}
                    {new Date(
                      selectedDate.getFullYear(),
                      selectedDate.getMonth(),
                      selectedDate.getDate(),
                      selectedTime.getHours(),
                      selectedTime.getMinutes()
                    ).toLocaleString("en-US", {
                      year: "numeric",
                      month: "2-digit",
                      day: "2-digit",
                      hour: "2-digit",
                      minute: "2-digit",
                      hour12: false,
                    })}
                  </p>
                )}
                {isGeneratingZoom && (
                  <p style={{ color: "#007bff", fontSize: "12px", marginTop: "5px" }}>
                    🔄 Generating Zoom meeting link...
                  </p>
                )}
              </div>
            </div>

            {/* Meeting Link and ID */}
            <div className="row" style={{ margin: "2% 2%" }}>
              <div className="col-sm-6">
                <label style={{ fontFamily: "poppins", fontSize: "12px", color: COLORS.text }}>
                  Meeting Link
                </label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  name="meeting_link"
                  placeholder="Meeting Link"
                  style={{ background: COLORS.background, color: COLORS.text, border: "none" }}
                  value={meetingLink}
                  readOnly
                />
              </div>
              <div className="col-sm-6">
                <label style={{ fontFamily: "poppins", fontSize: "12px", color: COLORS.text }}>
                  Meeting ID
                </label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  placeholder="Meeting ID"
                  style={{ background: COLORS.background, color: COLORS.text, border: "none" }}
                  value={meetingId}
                  readOnly
                />
              </div>
            </div>

            {/* Interviewer Selection */}
            {editableFields.select_interviewer && (
              <div className="row" style={{ margin: "2% 2%" }}>
                <div className="col-sm-12">
                  <label style={{ fontFamily: "poppins", fontSize: "12px", color: COLORS.text }}>
                    {editableFields.select_interviewer === "Third Party Interviewer"
                      ? "Third Party Interviewer"
                      : "Interviewer"}
                  </label>

                  {/* ── VIEW / READ-ONLY MODE ── */}
                  {isReadOnly ? (
                    <div
                      style={{
                        background: COLORS.background,
                        border: `1px solid ${COLORS.border}`,
                        borderRadius: "6px",
                        padding: "10px 14px",
                        marginTop: "6px",
                      }}
                    >
                      {editableFields.select_interviewer === "Third Party Interviewer" ? (
                        (() => {
                          const panel = Array.isArray(editableFields.interview_panel)
                            ? editableFields.interview_panel
                            : editableFields.interview_panel
                            ? [editableFields.interview_panel]
                            : [];
                          const selected = panel
                            .map((id) => tpInterviewers.find((i) => i.user_id === id))
                            .filter(Boolean);
                          return selected.length > 0 ? (
                            selected.map((tp) => (
                              <div key={tp.user_id} style={{ color: COLORS.text, fontSize: "13px", marginBottom: "4px" }}>
                                <strong>{tp.name}</strong> &nbsp;|&nbsp; {tp.email} &nbsp;|&nbsp; {tp.mobile}
                              </div>
                            ))
                          ) : (
                            <span style={{ color: COLORS.textSecondary, fontSize: "13px" }}>
                              {panel.join(", ") || "No interviewer selected"}
                            </span>
                          );
                        })()
                      ) : (
                        (() => {
                          const allInterviewers = [...technologists, ...managers, ...hrs];
                          const panel = Array.isArray(editableFields.interview_panel)
                            ? editableFields.interview_panel
                            : editableFields.interview_panel
                            ? [editableFields.interview_panel]
                            : [];
                          const selected = panel
                            .map((id) => allInterviewers.find((i) => i.panelist_id === id))
                            .filter(Boolean);
                          return selected.length > 0 ? (
                            selected.map((s) => (
                              <div key={s.panelist_id} style={{ color: COLORS.text, fontSize: "13px", marginBottom: "4px" }}>
                                <strong>{s.full_name}</strong> &nbsp;|&nbsp;
                                {s.official_email_id || "N/A"} &nbsp;|&nbsp;
                                {s.designation || "N/A"}
                              </div>
                            ))
                          ) : (
                            <span style={{ color: COLORS.textSecondary, fontSize: "13px" }}>
                              {panel.join(", ") || "No interviewer selected"}
                            </span>
                          );
                        })()
                      )}
                    </div>
                  ) : (
                    /* ── EDIT MODE ── */
                    <>
                      {!editableFields.round || !editableFields.select_interviewer ? (
                        <p style={{ color: COLORS.textSecondary, fontSize: "12px", marginTop: "8px" }}>
                          Please select a Round and Interviewer Type first.
                        </p>
                      ) : editableFields.select_interviewer === "Third Party Interviewer" ? (
                        <>
                          <TableContainer
                            component={Paper}
                            style={{ marginTop: "10px", borderRadius: "10px", maxHeight: "300px", overflow: "auto" }}
                          >
                            <Table size="small">
                              <TableHead style={{ background: COLORS.accent }}>
                                <TableRow>
                                  <TableCell style={{ color: "#fff", fontWeight: 600 }}>Name</TableCell>
                                  <TableCell style={{ color: "#fff", fontWeight: 600 }}>Email</TableCell>
                                  <TableCell style={{ color: "#fff", fontWeight: 600 }}>Mobile</TableCell>
                                  <TableCell style={{ color: "#fff", fontWeight: 600 }}>Status</TableCell>
                                  <TableCell style={{ color: "#fff", fontWeight: 600 }}>Action</TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {tpInterviewers.map((tp) => (
                                  <TableRow key={tp.user_id} style={{ background: COLORS.background }}>
                                    <TableCell style={{ color: COLORS.text, border: `1px solid ${COLORS.border}` }}>{tp.name}</TableCell>
                                    <TableCell style={{ color: COLORS.text, border: `1px solid ${COLORS.border}` }}>{tp.email}</TableCell>
                                    <TableCell style={{ color: COLORS.text, border: `1px solid ${COLORS.border}` }}>{tp.mobile}</TableCell>
                                    <TableCell style={{ color: COLORS.text, border: `1px solid ${COLORS.border}` }}>{tp.activation_status}</TableCell>
                                    <TableCell style={{ color: COLORS.text, border: `1px solid ${COLORS.border}` }}>
                                      <Button
                                        variant="contained"
                                        size="small"
                                        onClick={() => handleSelectTpInterviewer(tp.user_id)}
                                        style={{
                                          background: selectedTpInterviewer.includes(tp.user_id) ? COLORS.accent : COLORS.button_edit_bg,
                                          color: COLORS.text,
                                          fontFamily: "Poppins",
                                          textTransform: "none",
                                          fontWeight: selectedTpInterviewer.includes(tp.user_id) ? 700 : 500,
                                        }}
                                      >
                                        {selectedTpInterviewer.includes(tp.user_id) ? "Selected ✓" : "Select"}
                                      </Button>
                                    </TableCell>
                                  </TableRow>
                                ))}
                              </TableBody>
                            </Table>
                          </TableContainer>
                          {selectedTpInterviewer.length > 0 && (
                            <p style={{ color: COLORS.accent, fontSize: "12px", marginTop: "8px" }}>
                              ✓ Selected ({selectedTpInterviewer.length}):{" "}
                              {selectedTpInterviewer
                                .map((id) => tpInterviewers.find((i) => i.user_id === id)?.name)
                                .filter(Boolean)
                                .join(", ")}
                            </p>
                          )}
                        </>
                      ) : (
                        <>
                          {interviewerList.length === 0 ? (
                            <p style={{ color: COLORS.textSecondary, fontSize: "12px", marginTop: "8px" }}>
                              No interviewers found for the selected round and type.
                            </p>
                          ) : (
                            <TableContainer
                              component={Paper}
                              style={{ marginTop: "10px", borderRadius: "10px", maxHeight: "300px", overflow: "auto" }}
                            >
                              <Table size="small">
                                <TableHead style={{ background: COLORS.accent }}>
                                  <TableRow>
                                    <TableCell style={{ color: "#fff", fontWeight: 600 }}>Name</TableCell>
                                    <TableCell style={{ color: "#fff", fontWeight: 600 }}>Email</TableCell>
                                    <TableCell style={{ color: "#fff", fontWeight: 600 }}>Skills</TableCell>
                                    <TableCell style={{ color: "#fff", fontWeight: 600 }}>Designation</TableCell>
                                    <TableCell style={{ color: "#fff", fontWeight: 600 }}>Action</TableCell>
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {interviewerList.map((interviewer) => (
                                    <TableRow key={interviewer.panelist_id} style={{ background: COLORS.background }}>
                                      <TableCell style={{ color: COLORS.text, border: `1px solid ${COLORS.border}` }}>{interviewer.full_name}</TableCell>
                                      <TableCell style={{ color: COLORS.text, border: `1px solid ${COLORS.border}` }}>{interviewer.official_email_id || "N/A"}</TableCell>
                                      <TableCell style={{ color: COLORS.text, border: `1px solid ${COLORS.border}` }}>
                                        {Array.isArray(interviewer.skills) ? interviewer.skills.join(", ") : interviewer.skills || "N/A"}
                                      </TableCell>
                                      <TableCell style={{ color: COLORS.text, border: `1px solid ${COLORS.border}` }}>{interviewer.designation || "N/A"}</TableCell>
                                      <TableCell style={{ color: COLORS.text, border: `1px solid ${COLORS.border}` }}>
                                        <Button
                                          variant="contained"
                                          size="small"
                                          onClick={() => handleSelectInterviewer(interviewer.panelist_id)}
                                          style={{
                                            background: editableFields.interview_panel.includes(interviewer.panelist_id) ? COLORS.accent : COLORS.button_edit_bg,
                                            color: COLORS.text,
                                            fontFamily: "Poppins",
                                            textTransform: "none",
                                            fontWeight: editableFields.interview_panel.includes(interviewer.panelist_id) ? 700 : 500,
                                          }}
                                        >
                                          {editableFields.interview_panel.includes(interviewer.panelist_id) ? "Selected ✓" : "Select"}
                                        </Button>
                                      </TableCell>
                                    </TableRow>
                                  ))}
                                </TableBody>
                              </Table>
                            </TableContainer>
                          )}
                          {editableFields.interview_panel.length > 0 && (
                            <p style={{ color: COLORS.accent, fontSize: "12px", marginTop: "8px" }}>
                              ✓ Selected ({editableFields.interview_panel.length}):{" "}
                              {editableFields.interview_panel
                                .map((id) => interviewerList.find((i) => i.panelist_id === id)?.full_name)
                                .filter(Boolean)
                                .join(", ")}
                            </p>
                          )}
                        </>
                      )}
                    </>
                  )}
                </div>
              </div>
            )}

            {/* Reschedule */}
            <div className="row" style={{ margin: "2% 2%" }}>
              <div className="col-sm-6">
                <label style={{ fontFamily: "poppins", fontSize: "12px", color: COLORS.text }}>
                  Reschedule
                </label>
                <select
                  className="form-control form-control-sm"
                  name="reschedule"
                  style={{ background: COLORS.background, color: COLORS.text, border: "none" }}
                  value={editableFields.reschedule}
                  onChange={handleInputChange}
                  disabled={isReadOnly}
                >
                  <option value="Yes">Yes</option>
                  <option value="No">No</option>
                </select>
              </div>
            </div>

            {/* Buttons */}
            {!isReadOnly && (
              <div className="row" style={{ margin: "4% 2% 2% 2%" }}>
                <div className="col-sm-6">
                  <button
                    type="button"
                    className="btn btn-sm rounded-2 fw-medium"
                    onClick={handleReset}
                    style={{
                      margin: "0",
                      color: COLORS.background,
                      width: "100%",
                      border: "1px solid #1E1E1E",
                      backgroundColor: COLORS.button,
                      cursor: "pointer",
                    }}
                  >
                    Reset
                  </button>
                </div>
                <div className="col-sm-6">
                  <button
                    type="button"
                    className="btn btn-sm rounded-2 fw-medium"
                    onClick={handleSubmit}
                    style={{
                      margin: "0",
                      color: COLORS.background,
                      width: "100%",
                      border: "1px solid #1E1E1E",
                      background: COLORS.button_green_bg,
                      cursor: "pointer",
                    }}
                  >
                    Submit
                  </button>
                </div>
              </div>
            )}
          </div>
          <style>{`
            .react-datepicker__header {
              background-color: ${COLORS.accent} !important;
            }
            .date-picker-wrapper .react-datepicker__input-container input {
              color: ${COLORS.text} !important;
              background-color: transparent !important;
            }
            .date-picker-wrapper .react-datepicker__input-container input:disabled {
              color: #cccccc !important;
              background-color: transparent !important;
              opacity: 1 !important;
            }
            .date-picker-wrapper .react-datepicker__input-container input::placeholder {
              color: #888888 !important;
            }
            .react-datepicker,
            .react-datepicker__month-container {
              background-color: ${COLORS.primary} !important;
              border: 1px solid ${COLORS.border} !important;
              color: ${COLORS.text} !important;
              font-family: Poppins, sans-serif !important;
            }
            .react-datepicker__header,
            .react-datepicker__header--time,
            .react-datepicker-time__header {
              background-color: ${COLORS.secondary} !important;
              border-bottom: 1px solid ${COLORS.border} !important;
              color: ${COLORS.text} !important;
            }
            .react-datepicker__current-month,
            .react-datepicker__day-name,
            .react-datepicker-time__header {
              color: ${COLORS.text} !important;
            }
            .react-datepicker__navigation-icon::before {
              border-color: ${COLORS.text} !important;
            }
            .react-datepicker__navigation:hover *::before {
              border-color: ${COLORS.accent} !important;
            }
            .react-datepicker__day,
            .react-datepicker__day--outside-month {
              color: ${COLORS.text} !important;
            }
            .react-datepicker__day:hover {
              background-color: ${COLORS.hoverBg} !important;
              color: ${COLORS.accent} !important;
              border-radius: 50% !important;
            }
            .react-datepicker__day--selected,
            .react-datepicker__day--keyboard-selected {
              background-color: ${COLORS.accent} !important;
              color: #fff !important;
              border-radius: 50% !important;
            }
            .react-datepicker__day--today {
              font-weight: bold !important;
              color: ${COLORS.accent} !important;
            }
            .react-datepicker__day--disabled {
              color: #555555 !important;
              cursor: not-allowed !important;
            }
            .react-datepicker__day--disabled:hover {
              background-color: transparent !important;
              color: #555555 !important;
            }
            .react-datepicker__time-container {
              border-left: 1px solid ${COLORS.border} !important;
            }
            .react-datepicker__time-container .react-datepicker__time,
            .react-datepicker__time-container .react-datepicker__time-box {
              background-color: ${COLORS.primary} !important;
            }
            .react-datepicker__time-container .react-datepicker__time-list-item {
              color: ${COLORS.text} !important;
              background-color: ${COLORS.primary} !important;
            }
            .react-datepicker__time-container .react-datepicker__time-list-item:hover {
              background-color: ${COLORS.hoverBg} !important;
              color: ${COLORS.accent} !important;
            }
            .react-datepicker__time-container .react-datepicker__time-list-item--selected {
              background-color: ${COLORS.accent} !important;
              color: #ffffff !important;
            }
            .react-datepicker__time-container .react-datepicker__time-list-item--selected:hover {
              background-color: ${COLORS.accent} !important;
              color: #ffffff !important;
            }
            .react-datepicker__triangle::before {
              border-bottom-color: ${COLORS.border} !important;
              border-top-color: ${COLORS.border} !important;
            }
            .react-datepicker__triangle::after {
              border-bottom-color: ${COLORS.secondary} !important;
              border-top-color: ${COLORS.secondary} !important;
            }
          `}</style>
        </div>
      </div>
    </div>
  );
};

export default ViewModal;